// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"f5a58622","405":"28c12fd6","482":"99e2b9f1","855":"31aacea6"}[chunkId] + ".chunk.js";
};